import { ShiftClaimCancelationActors, WorkApplicationCancelationReasons } from '@types';

// TODO: Unify the types to both (ProjectCancellation and ShiftApplicationCancelationReasons) to use `cancelationReason` instead of `cancellationReason`

export const getWorkApplicationCancelationReason = (
  cancelationReason: WorkApplicationCancelationReasons
) => {
  const workApplicationCancelationReasonsToText = {
    // t('applications.cancelation_states.unknown')
    unknown: 'applications.cancelation_states.unknown',
    // t('applications.cancelation_states.by_fw')
    byFW: 'applications.cancelation_states.by_fw',
    // t('applications.cancelation_states.automatic_all_spots_filled')
    automaticAllSpotsFilled: 'applications.cancelation_states.automatic_all_spots_filled',
    // t('applications.cancelation_states.automatic_overlapping_shift')
    automaticOverlappingShift: 'applications.cancelation_states.automatic_overlapping_shift',
    // t('applications.cancelation_states.automatic_job_or_shift_details_changed')
    automaticJobOrShiftDetailsChanged:
      'applications.cancelation_states.automatic_job_or_shift_details_changed',
    // t('applications.cancelation_states.archived')
    archived: 'applications.cancelation_states.archived',
    // t('applications.cancelation_states.by_og')
    byOG: 'applications.cancelation_states.by_og',
    // t('applications.cancelation_states.by_hq')
    byHQ: 'applications.cancelation_states.by_hq',
    // t('applications.cancelation_states.by_not_welcome_list')
    byNotWelcomeList: 'applications.cancelation_states.by_not_welcome_list',
  } as const;

  return workApplicationCancelationReasonsToText[cancelationReason];
};

export const getWorkClaimCancelationReason = (cancelationActor: ShiftClaimCancelationActors) => {
  switch (cancelationActor) {
    case 'unknown':
      // t('placements.cancellation_states.unknown');
      return 'placements.cancellation_states.unknown';
    case 'byFW':
      // t('placements.cancellation_states.by_fw')
      return 'placements.cancellation_states.by_fw';
    case 'byOG':
      // t('placements.cancellation_states.by_og')
      return 'placements.cancellation_states.by_og';
    case 'byHQ':
      // t('placements.cancellation_states.by_hq')
      return 'placements.cancellation_states.by_hq';
    case 'byPartner':
      // t('placements.cancellation_states.by_partner')
      return 'placements.cancellation_states.by_partner';
  }
};
